import { gql } from "@apollo/client";

export const GET_ALL_PLANES = gql`
query allPlanCuidadoWithoutPaging(
    $where: PlanCuidadoFilterInput  
) {
    allPlanCuidadoWithoutPaging(where: $where)
    {
      idPlanCuidado
      codigoSap      
      nombre
      profesionales
      planCuidadoFase{
        planCuidadoFaseProfesional{
          idPlanCuidadoFaseProfesional
        }
      }
      tM,
      idTipoModulo,
      idTipoModuloNavigation {
        idTipoModulo,
        abreviacion,
        descripcion
      },
      envios,
      activo,
      planCuidadoAtributo{
        nombre
      }
      idPlanCuidadoEstado  
    }
}`;